<script lang="ts" setup>
  import { uploadTemporaryFiles } from '@/shared/services/fileService'
  import { WidgetAction } from '../types/WidgetAction'
  import { ref } from 'vue'
  defineProps<{
    isMultiple?: boolean
  }>()

  const uploadState = ref<'idle' | 'uploading' | 'done' | 'error'>('idle')

  const saveFile = async (event: any) => {
    const files = event.files
    uploadState.value = 'uploading'
    const fileUrls = await uploadTemporaryFiles(files)
    uploadState.value = 'done'
    emit('onWidgetAction', {
      action: 'onUpload',
      payload: { files: fileUrls },
    })
  }

  const emit = defineEmits<{
    (e: 'onWidgetAction', data: WidgetAction): void
  }>()
</script>
<template>
  <div class="field">
    <FileUpload
      mode="basic"
      :chooseLabel="`Seleccionar archivo${isMultiple ? 's' : ''}`"
      class="font-light text-sm w-12 text-center"
      style="font-size: 12px !important"
      custom-upload
      :multiple="isMultiple || false"
      @select="saveFile($event)"
      :disabled="uploadState === 'uploading' || uploadState === 'done'"
    >
      <template #content>
        <i class="pi pi-cloud-upload text-2xl"></i>
        <span v-if="uploadState === 'uploading'" class="ml-2">Subiendo...</span>
        <span v-else-if="uploadState === 'done'" class="ml-2"
          >¡Subida completa!</span
        >
      </template>
    </FileUpload>
  </div>
</template>
